module.exports = __webpack_public_path__ + "img/logo_full.e5f940cb.png";